const columnTitles = ({ translate }: { translate: (key: string) => string }): string[] => [
    translate(''),
    translate('visits.table.columnsTitles.contractCUIT'),
    translate('visits.table.columnsTitles.contract'),
    translate('visits.table.columnsTitles.establishment'),
    translate('visits.table.columnsTitles.visitType'),
    translate('visits.table.columnsTitles.visitDate'),
    translate('visits.table.columnsTitles.stateSRT'),
    translate('visits.table.columnsTitles.actions')
];

const columnWidths = ['5%', '15%', '15%', '15%', '15%', '10%', '10%', '5%'];

export { columnTitles, columnWidths };
